import { FormikProps } from 'formik';
import React, { useEffect, useMemo, useState } from 'react';
import { ISelectOption, ISpruceFieldProps, onInputChangeSelectList, Select, SpruceField } from '../../ui-toolkit';
import { labelComparator } from '../../utilities/labelComparator';

interface ILenderInformationForm {
  autoFocus: boolean;
  lenderOptions: Array<ISelectOption<string>>;
  clientCompanyList: ISelectOption<string>[];
  isNewOrder?: boolean;
}

export const LenderInformationForm: React.FC<ILenderInformationForm> = ({
  autoFocus,
  lenderOptions,
  clientCompanyList,
  isNewOrder,
}) => {
  const [lenderList, setList] = useState<Array<ISelectOption<string>>>([]);
  const onInputChange = onInputChangeSelectList(lenderOptions, setList);

  const lenderFieldName = isNewOrder ? 'lenderCompanyId' : 'lender_id';
  const clientFieldName = isNewOrder ? 'clientCompanyId' : 'client_id';

  useEffect(() => {
    // The original array is counted as "Read Only" so can't be sorted. This let's us sort it.
    setList([...lenderOptions]);
  }, [lenderOptions]);

  const onSelect = async (form: FormikProps<any>, value: ISelectOption<string> | null) => {
    if (value && value.value) {
      form.setFieldTouched(lenderFieldName);
      form.setFieldValue(lenderFieldName, onChangeToState(value));
      // get client with the same name
      const matchedCompany = clientCompanyList.find((t) => t.label === value.label);
      if (matchedCompany && !(form.values.client_id || form.values.clientCompanyId)) {
        form.setFieldTouched(clientFieldName);
        form.setFieldValue(clientFieldName, onChangeToState(matchedCompany));
      }
    } else {
      form.setFieldValue(lenderFieldName, null);
    }
  };

  const onChangeToState = (value: ISelectOption<string>) => value.value;
  const transformValueToSelect = (value: any) => (lenderList ? lenderList.find((t) => t.value === value) : null);

  const sortedOptions = useMemo(() => lenderList.toSorted(labelComparator), [lenderList]);

  return (
    <SpruceField name={lenderFieldName}>
      {({ field, formik }: ISpruceFieldProps) => (
        <Select
          {...field}
          value={transformValueToSelect(field.value) ? transformValueToSelect(field.value) : null}
          backspaceRemovesValue
          options={sortedOptions}
          isClearable
          onInputChange={onInputChange}
          onChange={(value) => onSelect(formik, value)}
          isRequired
          placeholder={`Select Lender`}
          autoFocus={autoFocus}
          data-test-id={field.name}
          name={field.name}
          label={'Lender'}
        />
      )}
    </SpruceField>
  );
};
